import { countWords, countSentences, countTextSyllables } from 'src/lib/string';

export const getScoreDescription = (score) => {
  let education;
  let description;

  if (score < 10) {
    education = 'professional';
    description = 'Extremely difficult to read';
  } else if (score < 30) {
    education = 'college graduate';
    description = 'Very difficult to read';
  } else if (score < 50) {
    education = 'college';
    description = 'Difficult to read';
  } else if (score < 60) {
    education = '10th to 12th grade';
    description = 'Fairly difficult to read';
  } else if (score < 70) {
    education = '8th & 9th grade';
    description = 'Plain english';
  } else if (score < 80) {
    education = '7th grade';
    description = 'Fairly easy to read';
  } else if (score < 90) {
    education = '6th grade';
    description = 'Easy to read';
  } else if (score <= 100) {
    education = '5th grade';
    description = 'Very easy to read';
  }

  return `${description}. Likely to be understood by a reader who has at least a ${education} education`;
};

export const getFleschReadingEaseScore = (copyText) => {
  const wordsCount = countWords(copyText);
  const sentencesCount = countSentences(copyText);
  const syllablesCount = countTextSyllables(copyText);

  const score =
    206.835 - 1.015 * (wordsCount / sentencesCount) - 84.6 * (syllablesCount / wordsCount);

  if (score < 0) {
    return 0;
  }

  if (score > 100) {
    return 100;
  }

  return Math.floor(score);
};
